import { getEnv } from '@monogrid/env'
import { getOptimizedImageURL } from '@monogrid/vue-boost/cms'

// cms usage
export function getSeoImageUrl (data) {
  const env = getEnv()
  return data
    ? `https://${env.SERVICE_TARGET_DOMAIN + getOptimizedImageURL(data, { w: 1200, h: 625, fm: 'jpg', fit: 'crop' })}`
    : undefined
}
